import template from './service.html';
import controller from './service.controller';
import './service.scss';

let serviceComponent = {
  bindings: {},
  template,
  controller
};

export default serviceComponent;



// WEBPACK FOOTER //
// ./client/app/components/service/service.component.js